import { AceIdentityEnv } from '@ace-clublabs/ace-identity';

interface EnvConfig {
  apiBaseUrl: string;
  redirectUri: string;
  aceIdentityEnv: AceIdentityEnv;
  loginUrl: string;
}

const getEnvConfig = (): EnvConfig => {
  const host = window.location.host;
  const redirectUri = `${window.location.origin}/enterprise/links-alp`;

  switch (true) {
    case host.includes('appdev') || host.includes('identity-sample'):
      return {
        apiBaseUrl: 'https://apidev1.ace.aaa.com',
        redirectUri,
        aceIdentityEnv: AceIdentityEnv.NonProd,
        loginUrl: 'https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login',
      };
    case host.includes('appqa'):
      return {
        apiBaseUrl: 'https://apiqa1.ace.aaa.com',
        redirectUri,
        aceIdentityEnv: AceIdentityEnv.NonProd,
        loginUrl: 'https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login',
      };
    case host.includes('appuat'):
      return {
        apiBaseUrl: 'https://apiuat1.ace.aaa.com',
        redirectUri,
        aceIdentityEnv: AceIdentityEnv.NonProd,
        loginUrl: 'https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login',
      };
    case host.includes('app.'):
      return {
        apiBaseUrl: 'https://api.ace.aaa.com',
        redirectUri,
        aceIdentityEnv: AceIdentityEnv.Prod,
        loginUrl: 'https://app.ace.aaa.com/enterprise/identity/#/login',
      };
    default:
      // Local development or unknown host - use dev environment
      return {
        apiBaseUrl: 'https://apidev1.ace.aaa.com',
        redirectUri,
        aceIdentityEnv: AceIdentityEnv.NonProd,
        loginUrl: 'https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login',
      };
  }
};

export const envConfig = getEnvConfig();

export const getEnvironmentName = (): string => {
  const host = window.location.host;
  if (host.includes('localhost')) return 'local';
  if (host.includes('appdev')) return 'dev';
  if (host.includes('appqa')) return 'qa';
  if (host.includes('appuat')) return 'uat';
  if (host.includes('app.')) return 'prod';
  return 'unknown';
};
